import { createFileRoute } from "@tanstack/react-router";
import { EsgPage, esgHead } from "@/pages/EsgPage";

export const Route = createFileRoute("/de/esg")({
  head: () => esgHead("de"),
  component: () => <EsgPage locale="de" />,
});
